import React, { useEffect, useState } from 'react';
import './ShippingPortal.scss';
import { ShippingLabelTypes } from 'src/api/shippingPortal';
import { CustomerInfo, Permissions } from '@lanterds/types';
import { getShipmentTypeFromContext } from 'src/util/helpers';
import { allCustomersDatum, allCustomersValue, SELECTED_SHIPPING_PORTAL_TYPE_LOCAL_STORAGE_KEY } from 'src/util/constants';
import OutboundLabels from './OutboundLabels/OutboundLabels';
import { Box } from '@mui/material';

import TransfersReturns from './TransfersReturns/TransfersReturns';
import { getCustomersByPermission } from 'src/api/customer';

const shippingLabelTypeToPermissionMap: Record<ShippingLabelTypes, Permissions> = {
    [ShippingLabelTypes.Outbound]: Permissions.shippingPortal_outbound,
    [ShippingLabelTypes.Return]: Permissions.shippingPortal_returns,
    [ShippingLabelTypes.Transfer]: Permissions.shippingPortal_transfers,
};

export default function ShippingPortal() {
    const shippingType = getShipmentTypeFromContext(
        SELECTED_SHIPPING_PORTAL_TYPE_LOCAL_STORAGE_KEY,
        'type',
    ) as ShippingLabelTypes;

    const [customers, setCustomers] = useState<CustomerInfo[]>([]);
    const [customersAreLoading, setCustomersAreLoading] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState<{ id: string; label: string } | null>(null);

    useEffect(() => {
        setCustomersAreLoading(true);
        getCustomersByPermission(shippingLabelTypeToPermissionMap[shippingType]).then((data: CustomerInfo[]) => {
            data.sort((a: CustomerInfo, b: CustomerInfo) =>
                a.customerName.toLocaleLowerCase().localeCompare(b.customerName.toLocaleLowerCase()),
            );

            if (data.length > 1) {
                setCustomers([allCustomersDatum as CustomerInfo, ...data]);
                setSelectedCustomer(allCustomersValue);
            } else {
                setCustomers(data);
            }

            setCustomersAreLoading(false);
        });
    }, [shippingType]);

    useEffect(() => {
        setSelectedCustomer(allCustomersValue);
        setCustomers([]);
    }, [shippingType]);

    return (
        <>
            {shippingType !== ShippingLabelTypes.Outbound && (
                <TransfersReturns
                    customersAreLoading={customersAreLoading}
                    customers={customers}
                    shippingType={shippingType}
                    selectedCustomer={selectedCustomer}
                    setSelectedCustomer={setSelectedCustomer}
                />
            )}
            {shippingType === ShippingLabelTypes.Outbound && (
                <OutboundLabels
                    customersAreLoading={customersAreLoading}
                    customers={customers}
                    shippingType={shippingType}
                    selectedCustomer={selectedCustomer}
                    setSelectedCustomer={setSelectedCustomer}
                />
            )}
        </>
    );
}
